import { render, staticRenderFns } from "./s-image.vue?vue&type=template&id=296b8048&scoped=true&"
import script from "./s-image.vue?vue&type=script&lang=js&"
export * from "./s-image.vue?vue&type=script&lang=js&"
import style0 from "./s-image.vue?vue&type=style&index=0&id=296b8048&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "296b8048",
  null
  
)

export default component.exports